import React, { useCallback, useEffect, useRef, useState } from 'react';
import classNames from 'classnames';
import throttle from 'lodash/throttle';
import classes from './catalog-scroll-continue-block.scss';
export const CatalogScrollContinueBlockComponent = ({
  submitButton,
  showStickyFooter
}) => {
  const footerPositionRef = useRef(null);
  const [isSticky, setIsSticky] = useState(false);
  useEffect(() => {
    const throttledHandler = throttle(handleScroll, 300);
    window.addEventListener('scroll', throttledHandler);
    handleScroll();
    return () => {
      window.removeEventListener('scroll', throttledHandler);
    };
  }, []);
  const handleScroll = useCallback(() => {
    if (!footerPositionRef.current) {
      return;
    }
    const {
      top
    } = footerPositionRef.current.getBoundingClientRect();
    const isNotInTheViewPort = top <= window.innerHeight;
    setIsSticky(!isNotInTheViewPort);
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    ref: footerPositionRef
  }, /*#__PURE__*/React.createElement("div", {
    className: classNames(classes.container, {
      [classes.sticky]: isSticky && showStickyFooter
    })
  }, /*#__PURE__*/React.createElement("p", {
    className: classes.text
  }, "Amazing! We just have a few more steps to confirm your order and shipping address!"), /*#__PURE__*/React.createElement("div", {
    className: classes.buttonSection
  }, submitButton)));
};